import { Field } from 'formik'
import React from 'react'
import { FormSectionTwoColumns } from '../../../../../../../../components/forms/FormSectionTwoColumns'
import { RichTextInput } from '../../../../../../../../components/inputs/RichTextInput/RichTextInput'

interface Props {}

export const B33SafetyPrinciples: React.FC<Props> = () => {
  return (
    <FormSectionTwoColumns
      sectionKey="b3.safetyPrinciples"
      title="B.3.3 Zásady bezpečnosti při užívání stavby"
    >
      <div className="sm:col-span-6 mt-5">
        <div className="mt-3 pl-7">
          <Field
            name={`b3.safetyPrinciples.description`}
            component={RichTextInput}
            aiHint="Zásady bezpečnosti při užívání stavby"
          />
        </div>
      </div>
    </FormSectionTwoColumns>
  )
}
